import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { StatisticsConceptsModel, StatisticsExpensesModel } from './statistics.model';
import { ApiResponse } from '../../models/base';

const STATISTIC_CONCEPTS = '/statistics/concepts';
const STATISTIC_EXPENSES = '/statistics/expenses';
const STATISTIC_INVOICES = '/statistics/invoices';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private readonly http = inject(HttpClient);

  public async listMostCostEffectiveConcept(): Promise<StatisticsConceptsModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<StatisticsConceptsModel>>(
        environment.apiUrl + STATISTIC_CONCEPTS
      )
    );

    return response.data;
  }

  public async listStatisticsExpenses(): Promise<StatisticsExpensesModel> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<StatisticsExpensesModel>>(
        environment.apiUrl + STATISTIC_EXPENSES
      )
    );

    return response.data;
  }

  public async listStatisticsInvoices(): Promise<any> {
    const response = await firstValueFrom(
      this.http.get<ApiResponse<any>>(environment.apiUrl + STATISTIC_INVOICES)
    );

    return response.data;
  }
}